// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__35RE_","title":"ClientReferral_title__nDXnM","itemText":"ClientReferral_itemText__2s-3j"};